var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',[_c('formulario',{ref:"formularioRef",on:{"getGuardar":_vm.getGuardar}})],1)],1),_c('v-row',[_c('v-col',[_c('listar',{ref:"listarRef",staticClass:"mt-2",on:{"GetItem":_vm.getSelectLista}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }